export default __webpack_public_path__ + "static/media/social.db97d85d.png";